<div class="invalid-feedback" [class.hide]="hide">
    <div>{{textValue}}</div>
</div>